/**
 * Bramki dostępu do treści.
 *
 * Podstawa i rozszerzenie to osobne produkty z osobnymi datami wygaśnięcia,
 * więc o wpuszczeniu do sesji decyduje dostęp do AKTYWNEJ domeny, a nie
 * globalne `has_access` (to ostatnie mówi tylko "ma cokolwiek").
 *
 * Fallback na stare pola jest celowy: account_status bywa czytany z cache /
 * localStorage zapisanego przed wdrożeniem rozszerzenia.
 */

/**
 * Czy błąd z API to odmowa z powodu braku dostępu do poziomu.
 * Backend bramkuje start sesji i arkuszy (402 + code: no_domain_access) — front
 * ma wtedy pokazać paywall zamiast generycznego błędu.
 */
export const isNoAccessError = (error) =>
    error?.response?.status === 402
    || error?.response?.data?.code === 'no_domain_access';

export const isAccessBlocked = (accountStatus) => {
    if (!accountStatus) return false;

    const hasAccess = accountStatus.has_active_domain_access
        ?? accountStatus.has_access;

    const expiresAt = accountStatus.active_domain_expires_at_timestamp
        ?? accountStatus.access_expires_at_timestamp;


    // Łapie naturalne wygaśnięcie między fetchami, nie tylko stan z momentu pobrania.
    const expiredByTimestamp = expiresAt != null && expiresAt <= Date.now() / 1000;

    return hasAccess === false || expiredByTimestamp;
};
